import { CoverPageBlankSlateKind } from "../blankSlates"
import { useCoverPageTranslate } from "../utils"

/**
 * The one name for adding each kind of Cover Page content. The design panel's
 * "Add …" rows and the page's Placeholders both read from here, so the two
 * always say the same thing.
 */
export const COVER_PAGE_ADD_LABELS: Record<
  CoverPageBlankSlateKind,
  { key: string; defaultValue: string }
> = {
  // The header's one-line pitch; the panel field is "Path summary".
  pitch: { key: "panel_sections.add_summary", defaultValue: "Add summary" },
  overview: { key: "panel_pitch.add_overview", defaultValue: "Add overview" },
  preview: {
    key: "panel_sections.add_steps_to_preview",
    defaultValue: "Add steps to preview"
  },
  offer: { key: "panel_sections.add_offer", defaultValue: "Add offer" },
  contributors: {
    key: "panel_sections.add_contributor",
    defaultValue: "Add contributor"
  },
  categories: {
    key: "panel_sections.add_category",
    defaultValue: "Add category"
  }
}

export function useCoverPageAddLabel(kind: CoverPageBlankSlateKind): string {
  const { t } = useCoverPageTranslate()
  const { key, defaultValue } = COVER_PAGE_ADD_LABELS[kind]
  return t(key, { defaultValue })
}
